/**
 * action types
 */
export const FETCH_LOGGED_IN_USER_DATA_SUCCESS =
  'FETCH_LOGGED_IN_USER_DATA_SUCCESS';
